import {ftime} from '@eitje/utils'
import {useGet} from '@eitje/api'

export const useInvoicingStatus = () => {
	const {data, loading} = useGet('billing_invoices/run_ready')

	const startedAt = ftime(data?.generate?.created_at, 'dateTime')
	const sentAt = ftime(data?.send?.created_at, 'dateTime')

	let status = 'not_sent'
	if (startedAt) status = 'in_process'
	if (sentAt) status = 'sent'
	if (loading) status = 'loading'

	return {startedAt, sentAt, status}
}
